<template>
    <el-row>
        <el-select v-model="provinceValue" placeholder="省" @change="selectProvince" style="width: 120px" size="small">
           <el-option
				 class="my-item"
                 v-for="(item,index) of provincearr"
                 :key="index"
                 :label="item.name"
                 :value="item.id"
             ></el-option>
        </el-select>
        <el-select v-model="cityValue" placeholder="市" @change="selectcity" style="width: 120px" size="small">
            <el-option class="my-item" v-for="(item,index) of cityarr" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select placeholder="区" @change="selectCountry" v-model="RegionValue" style="width: 120px" size="small">
          <el-option
			  class="my-item"
              v-for="(item,index) of regionarr"
              :key="index"
              :label="item.name"
              :value="item.id"
          ></el-option>
        </el-select>
    </el-row>
</template>
<script>
 
import { province } from '../utils/map.js'
 
export default {
 
  created () {
    this.provincearr = province
  },
  data () {
    return {
	      province: [],
	      cityarr: [],
	      regionarr: [],
	      provinceValue: '',
	      cityValue: '',
	      RegionValue: ''
    }
  },
  mounted () { },
  methods: {
   selectProvince (id) {
            this.cityarr = [];
            this.regionarr = [];
            this.cityValue = '';
            this.RegionValue = '';
            for (let item of this.provincearr) {
                if (id == item.id) {
                    console.log(item.name,'-所选省份')
                    this.cityarr = item.children
					this.provinceValue = item.name
                }
            }
			console.log(this.cityarr)
        },
        selectcity (id) {
            this.regionarr = [];
            this.RegionValue = '';
            for (let item of this.cityarr) {
                if (id == item.id) {
                    console.log(item.name,'-所选城市')
                    this.regionarr = item.children
					this.cityValue = item.name 
                }
            }
        },
        selectCountry(id){
            this.RegionValue = '';
            for (let item of this.regionarr) {
                if (id == item.id) {
                    console.log(item.name,'-所选区域')
					this.RegionValue = item.name
                }
            }
			this.$emit('selMap',this.provinceValue,this.cityValue,this.RegionValue)
        },
 
    }
  }
  
</script>
<style scoped type="text/css">
	/deep/.my-item{
		display: block!important;
	}
</style>


// WEBPACK FOOTER //
// map.vue?49c531d8